var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.231445C4.94303 0.231445 2.17081 1.90394 0.125192 4.62052C-0.0417306 4.84309 -0.0417306 5.15402 0.125192 5.37658C2.17081 8.09644 4.94303 9.76893 8 9.76893C11.057 9.76893 13.8292 8.09644 15.8748 5.37985C16.0417 5.15729 16.0417 4.84636 15.8748 4.6238C13.8292 1.90394 11.057 0.231445 8 0.231445ZM8.21929 8.35827C6.19004 8.48592 4.51427 6.81342 4.64191 4.7809C4.74665 3.10513 6.10494 1.74684 7.78071 1.6421C9.80996 1.51446 11.4857 3.18695 11.3581 5.21948C11.2501 6.89198 9.89179 8.25027 8.21929 8.35827ZM8.11783 6.80688C7.02465 6.87561 6.1213 5.97554 6.19331 4.88236C6.24895 3.97902 6.9821 3.24914 7.88545 3.19023C8.97862 3.12149 9.88197 4.02157 9.80996 5.11474C9.75105 6.02136 9.0179 6.75124 8.11783 6.80688Z",
    fill: "#8E8E8E",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEyeIcon);
export default __webpack_public_path__ + "static/media/view_eyeIcon.372414f0e0f4755607972a6b8b6da6aa.svg";
export { ForwardRef as ReactComponent };